export default Object.freeze({
  NATIONAL_ID: 'nationalId',
  PASSPORT: 'passport',
  BANK: 'bank',
  RECTO: 'recto',
  VERSO: 'verso'
});
